import script from "./fish-map.vue?vue&type=script&setup=true&lang=ts"
export * from "./fish-map.vue?vue&type=script&setup=true&lang=ts"

import "./fish-map.vue?vue&type=style&index=0&id=04eba3e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04eba3e0"]])

export default __exports__